import {css} from "lit-element/lit-element.js";
export default css`.gap-0 {
  gap: 0 !important;
}

.column-gap-0 {
  column-gap: 0 !important;
}

.row-gap-0 {
  row-gap: 0 !important;
}

.mt-0 {
  margin-top: 0 !important;
}

.mb-0 {
  margin-bottom: 0 !important;
}

.gap-1 {
  gap: 0.25rem !important;
}

.column-gap-1 {
  column-gap: 0.25rem !important;
}

.row-gap-1 {
  row-gap: 0.25rem !important;
}

.mt-1 {
  margin-top: 0.25rem !important;
}

.mb-1 {
  margin-bottom: 0.25rem !important;
}

.gap-2 {
  gap: 0.5rem !important;
}

.column-gap-2 {
  column-gap: 0.5rem !important;
}

.row-gap-2 {
  row-gap: 0.5rem !important;
}

.mt-2 {
  margin-top: 0.5rem !important;
}

.mb-2 {
  margin-bottom: 0.5rem !important;
}

.gap-3 {
  gap: 0.75rem !important;
}

.column-gap-3 {
  column-gap: 0.75rem !important;
}

.row-gap-3 {
  row-gap: 0.75rem !important;
}

.mt-3 {
  margin-top: 0.75rem !important;
}

.mb-3 {
  margin-bottom: 0.75rem !important;
}

.gap-4 {
  gap: 1rem !important;
}

.column-gap-4 {
  column-gap: 1rem !important;
}

.row-gap-4 {
  row-gap: 1rem !important;
}

.mt-4 {
  margin-top: 1rem !important;
}

.mb-4 {
  margin-bottom: 1rem !important;
}

.gap-5 {
  gap: 1.25rem !important;
}

.column-gap-5 {
  column-gap: 1.25rem !important;
}

.row-gap-5 {
  row-gap: 1.25rem !important;
}

.mt-5 {
  margin-top: 1.25rem !important;
}

.mb-5 {
  margin-bottom: 1.25rem !important;
}

.gap-6 {
  gap: 1.5rem !important;
}

.column-gap-6 {
  column-gap: 1.5rem !important;
}

.row-gap-6 {
  row-gap: 1.5rem !important;
}

.mt-6 {
  margin-top: 1.5rem !important;
}

.mb-6 {
  margin-bottom: 1.5rem !important;
}

.gap-7 {
  gap: 2rem !important;
}

.column-gap-7 {
  column-gap: 2rem !important;
}

.row-gap-7 {
  row-gap: 2rem !important;
}

.mt-7 {
  margin-top: 2rem !important;
}

.mb-7 {
  margin-bottom: 2rem !important;
}

.gap-8 {
  gap: 2.5rem !important;
}

.column-gap-8 {
  column-gap: 2.5rem !important;
}

.row-gap-8 {
  row-gap: 2.5rem !important;
}

.mt-8 {
  margin-top: 2.5rem !important;
}

.mb-8 {
  margin-bottom: 2.5rem !important;
}

.gap-9 {
  gap: 3rem !important;
}

.column-gap-9 {
  column-gap: 3rem !important;
}

.row-gap-9 {
  row-gap: 3rem !important;
}

.mt-9 {
  margin-top: 3rem !important;
}

.mb-9 {
  margin-bottom: 3rem !important;
}

.container {
  flex: 1 1 100%;
  box-sizing: border-box;
  padding: 0.5rem 1rem 1rem;
  width: 100%;
  margin-right: auto;
  margin-left: auto;
}
@media screen and (min-width: 576px) {
  .container {
    max-width: 540px;
  }
}
@media screen and (min-width: 768px) {
  .container {
    max-width: 720px;
  }
}
@media screen and (min-width: 992px) {
  .container {
    max-width: 960px;
  }
}
@media screen and (min-width: 1200px) {
  .container {
    max-width: 1140px;
  }
}
@media screen and (min-width: 1400px) {
  .container {
    max-width: 1320px;
  }
}

.atlas-grid {
  display: grid;
  grid-auto-rows: auto;
  grid-row-gap: var(--atlas-grid-row-gap);
}

:host {
  --atlas-grid-columns: 2;
  --atlas-grid-gutter: 0.5rem;
  --atlas-grid-row-gap: 1rem;
}

@media screen and (min-width: 768px) {
  :host {
    --atlas-grid-columns: 6;
    --atlas-grid-gutter: 1rem;
  }
}
@media screen and (min-width: 992px) {
  :host {
    --atlas-grid-columns: 12;
    --atlas-grid-gutter: 2rem;
    --atlas-grid-row-gap: 1.5rem;
  }
}
@media screen and (min-width: 1400px) {
  :host {
    --atlas-grid-columns: 12;
    --atlas-grid-gutter: 2rem;
    --atlas-grid-row-gap: 2rem;
  }
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
